import React from "react";
import styled from "styled-components";
import { Container, Eyebrow } from "./Container";
import { colors, fonts, media } from "../../theme";

export const PageHeader = ({ eyebrow, title, sub, children, dark = true }) => (
  <Wrap $dark={dark}>
    <Container>
      <Inner>
        {eyebrow && <Eyebrow color={dark ? colors.gold : colors.brand}>{eyebrow}</Eyebrow>}
        <h1>{title}</h1>
        {sub && <Sub>{sub}</Sub>}
        {children}
      </Inner>
    </Container>
  </Wrap>
);

const Wrap = styled.section`
  background: ${(p) => (p.$dark
    ? `radial-gradient(800px 400px at 90% -30%, rgba(242,181,61,0.18), transparent 60%), linear-gradient(180deg, ${colors.brand}, ${colors.brandDark})`
    : colors.surfaceAlt)};
  color: ${(p) => (p.$dark ? "white" : colors.ink)};
  padding: 90px 0 80px;

  h1 {
    color: ${(p) => (p.$dark ? "white" : colors.ink)};
    font-family: ${fonts.display};
  }

  ${media.sm} { padding: 64px 0 60px; }
`;

const Inner = styled.div`
  max-width: 760px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const Sub = styled.p`
  font-size: 18px;
  color: rgba(255,255,255,0.82);
  max-width: 640px;
  ${media.sm} { font-size: 16px; }
`;
